import { supabase } from "@/integrations/supabase/client";

const SESSION_KEY = "rpgcoin_client_session";
const FAV_KEY = "rpgcoin_favorites";

let timer: ReturnType<typeof setTimeout> | null = null;

const readFavorites = (): string[] => {
  try {
    const ids = JSON.parse(localStorage.getItem(FAV_KEY) || "[]");
    return Array.isArray(ids) ? ids.filter((x) => typeof x === "string") : [];
  } catch {
    return [];
  }
};

const readSession = (): { contato: string; token: string } | null => {
  try {
    const raw = localStorage.getItem(SESSION_KEY);
    if (!raw) return null;
    const s = JSON.parse(raw);
    if (!s?.contato || !s?.token) return null;
    return { contato: s.contato, token: s.token };
  } catch {
    return null;
  }
};

/**
 * Persists the local favorites list to the server for the logged-in user.
 * Used to power WhatsApp notifications when a saved ad is about to expire.
 * No-op for anonymous (not logged-in) visitors. Debounced + fire-and-forget.
 */
export const syncFavoritesToServer = () => {
  const session = readSession();
  if (!session) return;

  if (timer) clearTimeout(timer);
  timer = setTimeout(() => {
    supabase.functions
      .invoke("client-favoritos", {
        body: { contato: session.contato, token: session.token, anuncio_ids: readFavorites() },
      })
      .catch(() => {
        /* fire-and-forget */
      });
  }, 1200);
};
